/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  FC,
  useState,
  useEffect,
  useRef
} from 'react'

import { useIntl } from 'react-intl'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import {
  KTSVG,
  toAbsoluteUrl
} from '../../../_metronic/helpers'

import { useLocation } from 'react-router-dom'
import { Modal } from "react-bootstrap";

const FilterField = ({isOpen, onClosed, onSelect, fields, selected}) => {

  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();

  const [selectedFields, setSelectedFields] = useState<any>([]);


  useEffect(() => {
    if (isOpen) {
      setSelectedFields(selected);
    }
  }, [isOpen]);

  const confirm = () => {
    onSelect(selectedFields);

    onClosed();
  }

  const selectField = (id) => {
    if(!selectedFields.includes(id)) {
      setSelectedFields([...selectedFields, id]);
    } else{
        var array = [...selectedFields];
        var index = array.indexOf(id);

        if (index !== -1) {
          array.splice(index, 1);

          setSelectedFields(array);
        }
    }
  }

  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={isOpen}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >

          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-lg" className="d-flex justify-content-between">
                <h2>
                  <span className="text-white">Qual quadra deseja </span>
                  <span className="text-primary">jogar?</span>
                </h2>
            </Modal.Title>

            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
              <span className="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mx-auto mw-500px w-100 pt-0 pb-10">
              {fields && fields.map(field => <div className="w-100 cursor-pointer" data-kt-buttons="true" onClick={() => selectField(field.id)}>
                <label
                  className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-5 ${selectedFields.includes(field.id) && 'active'}`}

                >
                  <div className="d-flex align-items-center me-2" >
                    <div className="flex-grow-1">
                      <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                        {field.attributes.name}
                      </h2>
                    </div>
                  </div>

                  {<div className="form-check form-check-custom form-check-solid form-check-primary me-6" >
                    {selectedFields.includes(field.id) && <i className="las la-check fs-1"></i>}
                  </div>}
                </label>
              </div>)}

              <div className="mb-0 text-end">
                <button
                  className={`btn btn-primary`}
                  id="field-filter"
                  onClick={() => confirm()}
                >
                  <span className="indicator-label">Filtrar quadras</span>
                </button>
              </div>
            </div>
          </Modal.Body>
      </Modal>
    </>
  )
}

export {
  FilterField
}
